import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Case Studies', path: '/case-studies' },
    { name: 'Investors', path: '/investors' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-4 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_6400c586-49b7-4f08-ac06-403ab984ab21/artifacts/togb6r4n_Snip20260306_1.png" 
              alt="Repose Hotels Logo" 
              className="h-12 w-12 transition-transform duration-300 group-hover:scale-110"
            />
            <div>
              <h1 className={`font-playfair text-2xl font-bold tracking-wider transition-colors duration-300 ${
                isScrolled ? 'text-[#2B2B2B]' : 'text-white'
              }`}>
                REPOSE HOTELS
              </h1>
              <p className={`text-xs tracking-widest transition-colors duration-300 ${
                isScrolled ? 'text-[#B89C4A]' : 'text-[#B89C4A]'
              }`}>
                HOSPITALITY GROUP
              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-medium tracking-wide transition-all duration-300 relative group ${
                  isScrolled ? 'text-[#2B2B2B] hover:text-[#B89C4A]' : 'text-white hover:text-[#B89C4A]'
                }`}
              >
                {item.name}
                <span className={`absolute -bottom-1 left-0 w-0 h-0.5 bg-[#B89C4A] transition-all duration-300 group-hover:w-full ${
                  location.pathname === item.path ? 'w-full' : ''
                }`} />
              </Link>
            ))}
            <Button 
              size="sm" 
              className="bg-[#B89C4A] hover:bg-[#A58B3A] text-white transition-all duration-300 hover:scale-105"
              asChild
            >
              <Link to="/contact">Get Started</Link>
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden transition-colors duration-300 ${
              isScrolled ? 'text-[#2B2B2B]' : 'text-white'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-6 pb-6 border-t border-gray-200 pt-6">
            <div className="flex flex-col gap-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`font-medium tracking-wide transition-colors duration-300 py-2 ${
                    isScrolled ? 'text-[#2B2B2B] hover:text-[#B89C4A]' : 'text-white hover:text-[#B89C4A]'
                  } ${
                    location.pathname === item.path ? 'text-[#B89C4A]' : ''
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Button 
                className="bg-[#B89C4A] hover:bg-[#A58B3A] text-white w-full mt-4"
                asChild
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Link to="/contact">Get Started</Link>
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
